import React, { useEffect, useState } from "react";
import { WifiSlashIcon as WifiSlash } from "@phosphor-icons/react";

/** Slim banner shown while the device has no connection. Data on
 *  cached pages (dogs, pedigrees, care log, calendar) stays readable. */
export default function OfflineBanner() {
  const [offline, setOffline] = useState(
    typeof navigator !== "undefined" ? !navigator.onLine : false
  );

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (!offline) return null;
  return (
    <div
      className="sticky top-0 z-[60] flex items-center justify-center gap-2 bg-ink text-white text-[12px] font-semibold px-4 py-2"
      data-testid="offline-banner"
      role="status"
    >
      <WifiSlash size={14} weight="bold" className="text-gold" />
      You&rsquo;re offline — showing saved data. Changes will need a connection.
    </div>
  );
}
